import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Delta } from 'jsondiffpatch/lib/types';
import { hasLog, normalizeLog } from '../../../utils/normalize-log';
import { Lookups, SocialKeys, SOCIALS_KEYS_CONFIG } from '@ag-common-lib/public-api';
import { ChangesHistoryGridService } from 'ag-common-svc/lib/components/changes-history-grid/changes-history-grid.service';

@Component({
  selector: 'ag-shr-change-log-socials',
  templateUrl: './change-log-socials.component.html',
  styleUrls: ['./change-log-socials.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChangeLogSocialsComponent {
  @Input() log: Delta;

  protected readonly socialsKeys = [
    SocialKeys.socialMedia,
    SocialKeys.url,
    SocialKeys.socialType,
    SocialKeys.accountId,
    SocialKeys.accountType,
  ];
  protected readonly normalizeLog = normalizeLog;
  protected readonly hasLog = hasLog;
  protected readonly socialsLookup = SOCIALS_KEYS_CONFIG;

  constructor(private changesHistoryGridService: ChangesHistoryGridService) {}

  getLookup(key: SocialKeys) {
    switch (key) {
      case SocialKeys.socialType:
        return this.changesHistoryGridService.getLookupByName(Lookups.SocialTypes);

      case SocialKeys.socialMedia:
        return this.changesHistoryGridService.getLookupByName(Lookups.SocialMedia);

      default:
        return null;
    }
  }
}
